import React, { useEffect } from 'react';
import 'materialize-css/dist/css/materialize.min.css';
import { withRouter, Route, useLocation, useHistory } from 'react-router-dom';
import Projects from './pages/Projects/Projects';
import PageNotFound from './pages/PageNotFound/PageNotFound';
import { Navigation, Tabs } from '@eyesee/eyesee-hub-npm-ui';
import { mainData, mainStore } from './stores/mainStore';
import ProjectDetails from './pages/ProjectDetails/ProjectDetails';
import CellDetails from './pages/CellDetails/CellDetails';
import { observer } from 'mobx-react-lite';
import logo from './images/default-logo.png';
import PageTransPage from './pages/DownloadInstructionsPage/PageTransPage';
import ModalTransPage from './pages/InstructionsPage/ModalTransPage';

import '@eyesee/eyesee-hub-npm-ui/dist/index.css';
import './App.scss';
import { instructionStore } from './stores/instructionsStore';
import { Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';

const App = observer(() => {
    let history = useHistory();
    const location = useLocation();

    const onTabChange = (tab: 'PROJECTS' | 'MODAL TRANSLATIONS' | 'PAGE TRANSLATIONS') => {
        history.push(`/${tab}`);
        mainData.activeTab = tab;
    };
    useEffect(() => {
        instructionStore.getAvailableLangList();
        window.onbeforeunload = () => window.localStorage.removeItem('searchFor');
    });
    const showTabsRoutes = ['/', '/projects', '/modal-translations', '/page-translations'];
    return (
        <div className="App">
            <div className="App__nav"> <Link className="App__nav__link" to='/projects'></Link> {mainData?.user && <Navigation appLogo={logo} user={mainData?.user} title="hi" />}</div>
            {showTabsRoutes.includes(location.pathname) && (
                <div className="tabs-wrapper">
                    {' '}
                    <Tabs
                        onTabChange={onTabChange}
                        tabs={[
                            { name: 'projects', label: 'PROJECTS' },
                            { name: 'modal-translations', label: 'MODAL TRANSLATIONS' },
                            { name: 'page-translations', label: 'PAGE TRANSLATIONS' },
                        ]}
                    />
                </div>
            )}
            <Switch>
            <Route path="/" exact component={Projects} />            
            <Route path="/projects" exact component={Projects} />
            <Route path="/page-translations" exact component={PageTransPage} />
            <Route path="/modal-translations" exact component={ModalTransPage} />

            <Route path="/projects/:project_id" exact component={ProjectDetails} />
            <Route path={['/projects/:project_id/cell:cell_id', '/projects/new-project/cell:cell_id']} exact component={CellDetails} />
            <Route  component={PageNotFound} />
            </Switch>
        </div>
    );
});

export default withRouter(App);
